import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Message = _resolveComponent("Message")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_OlapFilterTree = _resolveComponent("OlapFilterTree")
  const _component_OlapFilterTable = _resolveComponent("OlapFilterTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-filter-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapFilterDialogDescriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.propFilter?.filter.name), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.clear
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.clear')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.selectedFilters.length > 0]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.treeLocked = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.treeLocked]
        ]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary p-ml-auto",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: _ctx.applyButtonDisabled,
          onClick: _ctx.apply
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.apply')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Message, {
        class: "p-m-4",
        severity: "info",
        closable: false,
        style: _ctx.olapFilterDialogDescriptor.styles.message
      }, {
        default: _withCtx(() => [
          (_ctx.treeLocked)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.treeLockedInfoMessage.partOne')), 1),
                _createVNode("b", null, _toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.treeLockedInfoMessage.partTwo')), 1),
                _createVNode("span", null, _toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.treeLockedInfoMessage.partThree')), 1)
              ]))
            : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.infoMessage')), 1))
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.olapDesignerMode && !_ctx.loading && _ctx.propFilter?.type === 'slicer')
        ? (_openBlock(), _createBlock(_component_SelectButton, {
            key: 1,
            id: "olap-filter-select-buttons",
            class: "p-ml-auto p-mr-4",
            modelValue: _ctx.mode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = $event)),
            options: _ctx.olapFilterDialogDescriptor.selectButtonOptions,
            optionValue: "value"
          }, {
            option: _withCtx((slotProps) => [
              _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", null, [
        (_ctx.mode === 'selectFields')
          ? (_openBlock(), _createBlock(_component_OlapFilterTree, {
              key: 0,
              propFilter: _ctx.filter,
              id: _ctx.id,
              clearTrigger: _ctx.clearTrigger,
              treeLocked: _ctx.treeLocked,
              onLoading: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loading = $event)),
              onFiltersChanged: _ctx.onFiltersChange,
              onLockTree: _cache[3] || (_cache[3] = ($event: any) => (_ctx.treeLocked = true)),
              onRootNode: _ctx.setRootNode
            }, null, 8, ["propFilter", "id", "clearTrigger", "treeLocked", "onFiltersChanged", "onRootNode"]))
          : (_openBlock(), _createBlock(_component_OlapFilterTable, {
              key: 1,
              propFilter: _ctx.filter,
              propLevels: _ctx.levels,
              parameters: _ctx.parameters,
              profileAttributes: _ctx.profileAttributes
            }, null, 8, ["propFilter", "propLevels", "parameters", "profileAttributes"]))
      ], 512), [
        [_vShow, !_ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}